export const APP_INSIGHTS_FEATURES = {
  // [FE] = Features
  GET_ME: `[FE] GET ME`,
  GET_ME_SUCCESS: `[FE] GET ME SUCCESS`,
  GET_ME_ERROR: `[FE] GET ME ERROR`,

  GET_INSTALLATION_FEATURES: `[FE] GET INSTALLATION FEATURES`,
  GET_INSTALLATION_FEATURES_SUCCESS: `[FE] GET INSTALLATION FEATURES SUCCESS`,
  GET_INSTALLATION_FEATURES_ERROR: `[FE] GET INSTALLATION FEATURES ERROR`,

  GET_SUPPORTED_FEATURES: `[FE] GET SUPPORTED FEATURES`,
  GET_SUPPORTED_FEATURES_SUCCESS: `[FE] GET SUPPORTED SUCCESS`,
  GET_SUPPORTED_FEATURES_ERROR: `[FE] GET SUPPORTED FEATURES ERROR`,

  GET_GATEWAY_FEATURES: `[FE] GET GATEWAY FEATURES`,
  GET_GATEWAY_FEATURES_SUCCESS: `[FE] GET GATEWAY FEATURES SUCCESS`,
  GET_GATEWAY_FEATURES_ERROR: `[FE] GET GATEWAY FEATURES ERROR`,

  GET_ALL_GATEWAY_FEATURES: `[FE] GET ALL GATEWAY FEATURES`,
  GET_ALL_GATEWAY_FEATURES_SUCCESS: `[FE] GET ALL GATEWAY FEATURES SUCCESS`,
  GET_ALL_GATEWAY_FEATURES_ERROR: `[FE] GET ALL GATEWAY FEATURES ERROR`,

  GET_DHW_STATE_CHANGED: `[FE] GET DHW STATE CHANGED`,
};
